module.exports = __webpack_public_path__ + "img/add_theme_desktop_4.5990dca1.png";